export default "//cloud.imgsmail.ru/cloud.mail.ru/126090/img/build/errors/error-504.png";